import React from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import { Box, Text, Icon } from 'components/ui';
import {
    colors, space, radii, mediaQueries, shadows
} from 'style/config';
import ProductImage from 'components/Product/ProductImage';

const ProductCard = ({ product, index, onRemove, getText }) => {
    const handleRemove = () => {
        if (onRemove) {
            onRemove(product.productId);
        }
    };

    return (
        <Box css={styles.productCard}>
            <Box css={styles.productImageContainer}>
                <ProductImage
                    id={product?.currentSku?.skuId}
                    skuImages={product?.heroImage ? { image: product?.heroImage } : product?.currentSku?.skuImages}
                    altText={product?.currentSku?.imageAltText || product?.displayName || ''}
                    size={[74, 74]}
                    disableLazyLoad={true}
                    objectFit='cover'
                    src={product?.heroImage}
                />
            </Box>
            <Box css={styles.productInfoContainer}>
                {product?.brandName && (
                    <Text
                        is='p'
                        fontWeight='bold'
                        fontSize='sm'
                        lineHeight='tight'
                        css={[styles.overflow, styles.noWrap]}
                    >
                        {product.brandName}
                    </Text>
                )}
                {product?.displayName && (
                    <Text
                        is='p'
                        lineHeight='tight'
                        numberOfLines={2}
                        css={styles.overflow}
                    >
                        {product.displayName}
                    </Text>
                )}
                {product?.currentSku?.listPrice && (
                    <Text
                        is='p'
                        lineHeight='tight'
                        fontWeight='bold'
                        css={styles.overflow}
                    >
                        {product?.currentSku?.listPrice}
                    </Text>
                )}
            </Box>
            <button
                type='button'
                onClick={handleRemove}
                aria-label={getText('removeProduct')}
                css={styles.removeButton}
                data-at={Sephora.debug.dataAt(`compare_drawer_remove_${index + 1}`)}
            >
                <Icon
                    name='x'
                    size={14}
                    aria-hidden={true}
                />
            </button>
        </Box>
    );
};

ProductCard.propTypes = {
    product: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
    onRemove: PropTypes.func.isRequired,
    getText: PropTypes.func.isRequired
};

const styles = {
    productCard: {
        position: 'relative',
        width: '100%',
        height: '100%',
        overflow: 'visible',
        backgroundColor: colors.white,
        boxShadow: shadows.light,
        display: 'flex',
        flexDirection: 'column',
        borderRadius: `${radii[2]}px`,
        [mediaQueries.md]: {
            flexDirection: 'row',
            padding: `${space[4]}px`,
            gap: `${space[2]}px`,
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            height: '106px',
            boxSizing: 'border-box'
        }
    },
    productImageContainer: {
        width: '100%',
        height: '100%',
        position: 'relative',
        img: {
            borderRadius: `${radii[2]}px`
        },
        [mediaQueries.md]: {
            width: '74px',
            height: '74px',
            flexShrink: 0,
            borderRadius: `${radii[2]}px`
        }
    },
    productInfoContainer: {
        display: 'none',
        flex: '1 0 0',
        minWidth: 0,
        flexDirection: 'column',
        gap: '2px',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        [mediaQueries.md]: {
            display: 'flex'
        }
    },
    overflow: {
        width: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    noWrap: {
        whiteSpace: 'nowrap'
    },
    removeButton: {
        position: 'absolute',
        top: `${space[1]}px`,
        right: `${space[1]}px`,
        width: '14px',
        height: '14px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        padding: 0,
        zIndex: 10,
        background: 'none',
        border: 'none',
        [mediaQueries.md]: {
            top: '0',
            right: '0',
            position: 'relative'
        }
    }
};

export default wrapFunctionalComponent(ProductCard, 'ProductCard');
